<action-bar>
  @if (isAdmin) {
    <action-bar-control>
      <!-- <ps-autocomplete-select [selectList]="clients" id="client" [(ngModel)]="selectedClient"
      [placeHolderText]="'Select Client'" (selectionChanged)="onSelectClient($event)">
    </ps-autocomplete-select> -->
    <select [ngModel]="selectedClient" (ngModelChange)="onSelectClient($event)" style="height: 30px;">
      @for (option of clients; track option) {
        <option [ngValue]="option">{{option.name}}</option>
      }
    </select>
  </action-bar-control>
}
<action-button [iconClass]="'fa fa-plus'" [className]="'action-primary'" (actionClick)="onNewClick()" [disabled]="!selectedClient">
  Add Position To Client
</action-button>
<action-button (actionClick)="exportDataAsCsv()" [iconClass]="'fa fa-save'" [className]="'action-secondary'">
  Export
</action-button>
</action-bar>

<div class="row">
  <div class="col table-title">
    <h1>Positions</h1>
  </div>
  <div class="col">
    <div class="pull-right">
      Quick Search:
      <input type="text" [(ngModel)]="inputQuickSearch" id="filter-text-box" placeholder="Type here..." (keyup)="onFilterTextBoxChanged()"/>
      <button (click)="resetFilters()">Reset Filters</button>
    </div>
  </div>
</div>

<div class="row" id="GridWithH1">
  <div class="col" style="Width: 100%;Height:100%;" >
    <ag-grid-angular
      class="ag-theme-material"
      style="Width: 100%;Height:100%;"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>  </div>
  </div>
  <div class="gridFooter" >
    <span>Rows per page:</span>
    <select style="display:inline;" [ngModel]="selectedPaginationOption" (change)="onChangePaginationOption($event.target.value)"> <!--[(ngModel)]="selectedPaginationOption"-->
      @for (option of paginationOptions; track option) {
        <option [value]="option.id">{{option.name}}</option>
      }
    </select>
  </div>